// French translations
const fr = {
  // Common
  common: {
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    submit: "Soumettre",
    next: "Suivant",
    previous: "Précédent",
    back: "Retour",
    home: "Accueil",
    dashboard: "Tableau de bord",
    upgrade: "Mettre à niveau",
    viewPlans: "Voir les forfaits",
    logOut: "Déconnexion",
    contactUs: "Nous contacter",
    managePlan: "Gérer le forfait",
    settings: "Paramètres",
    account: "Compte",
    language: "Langue",
    english: "English",
    french: "Français"
  },

  // Navigation
  nav: {
    plan: "Planifier",
    learn: "Apprendre",
    practice: "Pratiquer",
    finalReadiness: "Préparation finale",
    account: "Compte",
    dashboard: "Tableau de bord",
    journeyTracker: "Suivi du parcours",
    studyPlanner: "Planificateur d'études",
    discoverCanada: "Découvrir le Canada",
    studyGuide: "Guide d'étude",
    flashcards: "Cartes mémoire",
    weakAreas: "Points faibles",
    chapterPractice: "Pratique par chapitre",
    simulations: "Simulations",
    mockTests: "Tests blancs",
    analytics: "Analyses",
    progressSummary: "Résumé des progrès"
  },

  // Auth
  auth: {
    welcomeBack: "Bon retour",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    createAccount: "Créer votre compte",
    continueWithGoogle: "Continuer avec Google",
    orContinueWithEmail: "Ou continuer par courriel",
    email: "Courriel",
    password: "Mot de passe",
    fullName: "Nom complet",
    language: "Langue",
    english: "Anglais",
    french: "Français",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    dontHaveAccount: "Vous n'avez pas de compte?",
    signInToContinue: "Connectez-vous pour continuer votre préparation à la citoyenneté",
    startJourney: "Commencez votre parcours vers la citoyenneté canadienne aujourd'hui",
    selectLanguage: "Sélectionnez votre langue préférée"
  },

  // Dashboard
  dashboard: {
    welcomeBack: "Bon retour",
    readyToStart: "Prêt à commencer votre parcours vers la citoyenneté canadienne?",
    startPractice: "Commencer la pratique",
    dayStreak: "jours consécutifs",
    longest: "Le plus long",
    total: "Total",
    studyDays: "jours d'étude",
    logTodaysStudy: "Enregistrer l'étude d'aujourd'hui",
    testsTaken: "Tests effectués",
    testsPassed: "Tests réussis",
    averageScore: "Score moyen",
    studyStreak: "Séquence d'étude",
    quickActions: "Actions rapides",
    recentTests: "Tests récents",
    viewAll: "Voir tout",
    yourProgress: "Votre progression",
    overallReadiness: "Préparation globale"
  },

  // Landing Page
  landing: {
    heroTitle: "Réussissez votre examen de citoyenneté canadienne du premier coup.",
    heroSubtitle: "Garanti.",
    heroDescription: "Votre boîte à outils complète pour réussir: Préparez-vous avec plus de 500 questions d'examen, des tests de simulation, des exercices par chapitre, des cartes mémoire et tous les outils essentiels.",
    getStarted: "Commencer",
    learnMore: "En savoir plus",
    howItWorks: "Comment ça marche",
    features: "Fonctionnalités",
    reviews: "Avis",
    pricing: "Tarifs",
    passRate: "Chapitres couverts",
    usersPassed: "Utilisateurs ont réussi",
    practiceQuestions: "Questions pratiques",
    whyChooseUs: "Pourquoi choisir CanadaTestPrep?",
    testimonials: "Ce que disent nos utilisateurs",
    faq: "Foire aux questions",
    readyToPass: "Prêt à réussir votre examen?",
    joinUsers: "Rejoignez plus de 1 500 nouveaux Canadiens qui ont réussi avec CanadaTestPrep",
    unlockQuestions: "Débloquez les 500+ questions",
    bePartOf: "Faites partie des",
    newCitizens: "nouveaux citoyens qui ont réussi leurs examens avec nous.",
    navLogIn: "Connexion",
    navDashboard: "Tableau de bord",
    excellent: "Excellent",
    basedOnReviews: "Basé sur 200+ avis",
    keyBenefits: {
      questions: "Plus de 500 questions vues à l'examen",
      studyGuide: "Guide d'étude officiel et leçons",
      simulator: "Simulateur d'examen réel (format gouv.)",
      aiTools: "Outils intelligents et détection des lacunes",
      guarantee: "Garantie de réussite: réussissez ou remboursé"
    },
    stats: {
      usersPassed: "Utilisateurs ont réussi",
      testQuestions: "Questions d'examen",
      passRate: "Chapitres couverts",
      userRating: "Note des utilisateurs"
    },
    comparison: {
      nervousTitle: "Nerveux à propos de votre examen?",
      funWay: "Découvrez une façon amusante et intuitive de vous préparer",
      funDescription: "Nous sommes en 2026: pourquoi se contenter de méthodes dépassées? Nous avons regroupé tous les outils dans un programme engageant, conçu pour renforcer votre confiance une question à la fois.",
      oldWay: "Livre seul",
      newWay: "CanadaTestPrep Premium",
      highFailure: "Taux d'échec élevé",
      passRateBadge: "Taux de réussite élevé"
    },
    guarantee: {
      title: "Garantie de réussite: Réussissez votre examen ou remboursé",
      description: "Même si vous avez déjà échoué et que les examens vous stressent, avec CanadaTestPrep Premium, vous êtes 100% garanti de réussir. Complétez notre programme et ne réussissez pas? Nous vous remboursons intégralement."
    },
    howItWorksSection: {
      title: "Soyez parfaitement préparé pour votre examen de citoyenneté",
      description: "Notre cours est entièrement en ligne et conçu pour s'adapter à votre emploi du temps chargé, pas l'inverse.",
      step1Title: "Commencez par le guide d'étude",
      step1Desc: "Apprenez chapitre par chapitre avec notre guide complet couvrant les 11 chapitres de Découvrir le Canada.",
      step2Title: "Pratiquez avec des questions",
      step2Desc: "Testez vos connaissances avec plus de 500 questions par chapitre et des commentaires instantanés.",
      step3Title: "Passez des tests de simulation",
      step3Desc: "Découvrez le format réel de l'examen avec notre simulateur de style gouvernemental.",
      step4Title: "Réussissez votre examen",
      step4Desc: "Présentez-vous à votre examen confiant et préparé. Nos outils de pratique complets vous aident à vous présenter préparé et confiant."
    },
    featuresSection: {
      title: "Tout ce dont vous avez besoin pour réussir",
      description: "Des outils complets conçus pour vous aider à maîtriser l'examen de citoyenneté canadienne",
      feature1: "500+ questions pratiques",
      feature1Desc: "Banque de questions complète couvrant les 11 chapitres avec des explications détaillées.",
      feature2: "200+ cartes mémoire",
      feature2Desc: "Maîtrisez les faits clés, dates et personnalités avec des cartes mémoire interactives.",
      feature3: "Simulateur d'examen réel",
      feature3Desc: "Découvrez l'interface exacte de l'examen du gouvernement avant le jour J.",
      feature4: "Planificateur d'études intelligent",
      feature4Desc: "Obtenez un calendrier d'étude personnalisé basé sur votre date d'examen.",
      feature5: "Détection des points faibles",
      feature5Desc: "L'analyse intelligente identifie les chapitres nécessitant plus d'attention selon vos résultats.",
      feature6: "Compilations importantes",
      feature6Desc: "Toutes les dates importantes, personnalités clés et résumés en un seul endroit.",
      feature7: "Suivi du parcours",
      feature7Desc: "Comprenez chaque étape de la demande à la cérémonie de serment.",
      feature8: "Séries d'études",
      feature8Desc: "Développez des habitudes constantes avec des séries quotidiennes et des récompenses."
    },
    testimonialsSection: {
      title: "\"Ces questions étaient identiques à mon vrai examen\"",
      description: "Rien de pire que de rencontrer une question jamais vue. CanadaTestPrep s'assure que vous les avez toutes vues.",
      fromActualUsers: "DE VRAIS CANDIDATS"
    },
    pricingSection: {
      title: "Laissez-nous vous aider à réussir facilement",
      description: "Prix simples, sans frais cachés. Achat unique, pas d'abonnement.",
      simplePricing: "TARIFICATION SIMPLE"
    },
    ctaSection: {
      title: "Quand vous devez absolument réussir votre examen de citoyenneté",
      description: "Vous n'avez pas de temps et un million de responsabilités. Si vous allez étudier, vous devez être sûr de réussir du premier coup.",
      soYouCanGetBack: "Pour retourner à votre vie."
    },
    footer: {
      madeWithLove: "Fait avec amour au Canada",
      tagline: "La plateforme #1 de préparation à l'examen de citoyenneté canadienne"
    }
  },

  // Study
  study: {
    studyGuide: "Guide d'étude",
    masterChapters: "Maîtrisez chaque chapitre avec des résumés, des points clés et des dates importantes",
    chapters: "Chapitres",
    dates: "Dates",
    people: "Personnalités",
    importantDates: "Dates importantes",
    keyHistoricalDates: "Dates historiques clés pour l'examen de citoyenneté",
    importantPersonalities: "Personnalités importantes",
    keyFigures: "Personnages historiques clés à connaître",
    chapterSummary: "Résumé du chapitre",
    content: "Contenu",
    keyPoints: "Points clés",
    studyTips: "Conseils d'étude"
  },

  // Flashcards
  flashcards: {
    title: "Cartes mémoire",
    subtitle: "Maîtrisez les faits clés avec des cartes mémoire interactives",
    flipCard: "Retourner la carte",
    showAnswer: "Afficher la réponse",
    hideAnswer: "Masquer la réponse",
    nextCard: "Carte suivante",
    prevCard: "Carte précédente",
    cardOf: "Carte {current} sur {total}"
  },

  // Tests
  tests: {
    startTest: "Commencer le test",
    submitTest: "Soumettre le test",
    confirmSubmission: "Confirmer la soumission",
    timeRemaining: "Temps restant",
    questionOf: "Question {current} sur {total}",
    reviewLater: "Je veux revoir cette réponse plus tard",
    unansweredWarning: "Vous avez {count} questions sans réponse. Êtes-vous sûr de vouloir soumettre?",
    testComplete: "Test terminé",
    yourScore: "Votre score",
    passed: "Réussi",
    failed: "Échoué",
    reviewAnswers: "Revoir les réponses",
    tryAgain: "Réessayer",
    backToTests: "Retour aux tests"
  },

  // Contact
  contact: {
    title: "Nous contacter",
    subtitle: "Vous avez des questions ou des commentaires? Nous serions ravis de vous entendre.",
    sendMessage: "Envoyez-nous un message",
    yourName: "Votre nom",
    emailAddress: "Adresse courriel",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer le message",
    sending: "Envoi en cours...",
    successTitle: "Message envoyé!",
    successMessage: "Merci de nous avoir contactés. Nous avons reçu votre message et nous vous répondrons dès que possible.",
    responseTime: "Délai de réponse",
    responseInfo: "Nous répondons généralement dans les 24 à 48 heures. Pour les questions urgentes, veuillez inclure « URGENT » dans votre sujet."
  },

  // Pricing
  pricing: {
    title: "Choisissez votre forfait",
    subtitle: "Commencez gratuitement, passez à niveau quand vous êtes prêt",
    free: "Gratuit",
    pro: "Pro",
    premium: "Premium",
    perWeek: "/semaine",
    lifetime: "À vie",
    currentPlan: "Forfait actuel",
    choosePlan: "Choisir ce forfait",
    mostPopular: "Le plus populaire",
    bestValue: "Meilleur rapport qualité-prix"
  },

  // Discover Canada
  discoverCanada: {
    title: "Découvrir le Canada",
    subtitle: "Le guide d'étude officiel pour l'examen de citoyenneté canadienne",
    officialGuide: "Découvrir le Canada: Les droits et responsabilités liés à la citoyenneté",
    guideDescription: "Ceci est le guide d'étude officiel publié par le gouvernement du Canada. Il contient toutes les informations que vous devez connaître pour l'examen de citoyenneté, y compris l'histoire du Canada, le gouvernement, les droits et les responsabilités.",
    readOnline: "Lire en ligne",
    downloadPdf: "Télécharger le PDF",
    whatsInside: "Contenu du guide"
  },

  // Account Settings
  account: {
    title: "Paramètres du compte",
    personalInfo: "Informations personnelles",
    email: "Courriel",
    name: "Nom",
    subscription: "Abonnement",
    languagePreference: "Préférence linguistique",
    languageDescription: "Choisissez votre langue préférée pour l'application",
    dangerZone: "Zone dangereuse",
    resetProgress: "Réinitialiser toute la progression",
    resetDescription: "Cela supprimera définitivement tout votre historique de tests, vos scores, vos notes, votre progression de parcours et vos séries d'études. Votre compte restera actif.",
    resetConfirmTitle: "Êtes-vous absolument sûr?",
    resetConfirmDescription: "Cette action est irréversible. Toutes vos données de progression seront définitivement supprimées.",
    resetButton: "Réinitialiser ma progression",
    resetting: "Réinitialisation...",
    resetSuccess: "Progression réinitialisée avec succès! Vous pouvez recommencer à zéro.",
    typeToConfirm: "Tapez RESET pour confirmer"
  },

  // Admin Dashboard
  admin: {
    title: "Tableau de bord administrateur",
    overview: "Aperçu",
    totalUsers: "Total des utilisateurs",
    newThisWeek: "Nouveaux cette semaine",
    totalRevenue: "Revenus totaux",
    totalContacts: "Demandes de contact",
    subscriptions: "Abonnements",
    freeUsers: "Utilisateurs gratuits",
    proUsers: "Abonnés Pro",
    premiumUsers: "Abonnés Premium",
    languageStats: "Préférences linguistiques",
    englishUsers: "Utilisateurs anglophones",
    frenchUsers: "Utilisateurs francophones",
    recentUsers: "Utilisateurs récents",
    contactSubmissions: "Soumissions de contact",
    markAsRead: "Marquer comme lu",
    markAsReplied: "Marquer comme répondu",
    resolve: "Résoudre",
    status: "Statut",
    newContact: "Nouveau",
    readContact: "Lu",
    repliedContact: "Répondu",
    resolvedContact: "Résolu"
  }
};

export default fr;
